import React, {FC} from "react";
import {TagProps} from "./Tag.types";
import styles from "./Tag.module.scss";
import {IconContext} from "react-icons";
import {CITimes} from "@dua.design/icons";
import Typography from "../Typography";
import {useScreenSizes} from "../../hooks";

const Tag: FC<TagProps> = ({
                               color="link",
                               icon,
                               onClick,
                               onClickDismiss,
                               disabled,
                               children,
                               ...rest
                           }) => {
    const onlyStartIcon = !children && !!icon;
    const className = `${styles.Tag}  ${styles[color]}
    ${!onClick ? styles.notClickable : ""} 
    ${onlyStartIcon ? styles.iconOnly : ""} 
    ${onClickDismiss ? styles.HasDismissTagButton : ""} ${
        disabled ? styles.disabled : ""
    }`;

    const size = useScreenSizes();
    return (
        <div className={[className, rest.className].join(" ")}>
            <button
                onClick={onClick}
                className={styles.TagButton}
                type="button"
                data-testid="button"
            >
                <IconContext.Provider value={{size: size === 'sm' ? '16px' : '14px'}}>
                    {!!icon && icon}
                    {!!children && (
                        <Typography variant="p" token={100} weight="normal">
                            {children}
                        </Typography>
                    )}
                </IconContext.Provider>
            </button>
            {onClickDismiss && (
                <button
                    type="button"
                    className={styles.TagButtonDismiss}
                    onClick={onClickDismiss}
                >
                    <IconContext.Provider value={{size: size === 'sm' ? '16px' : '14px'}}>
                        <CITimes/>
                    </IconContext.Provider>
                </button>
            )}
        </div>
    );
};

export default Tag;
